module.exports = __webpack_public_path__ + "media/barometer/lit-fin-201-45e0a04b.png";